import React from 'react'
 
import { TabsValue } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import {  useNavigate,  useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import {  useDocumentTitle, useMediaQuery } from '@mantine/hooks';
import { Tabs } from '@mantine/core';
// import AddUsers from 'src/components/organisation/AddUsers/page';
import Notification from './Notification/page';
import ManageCompanies from './ManageCompanies';
import { Mail, Trello  } from '@geist-ui/icons';

 
const ManageCompany = (): JSX.Element => {
  const notificationsRef =useRef<HTMLDivElement>(null);
  const managecompaniesRef =useRef<HTMLDivElement>(null);

  
  const hiddenRef = useRef<HTMLDivElement>(null); // Hidden element for initial focus reset

  const navigate = useNavigate();
  const { pageTab } = useParams();
 
  const [t] = useTranslation('account');
  const [c] = useTranslation('common');
  useDocumentTitle(t('title'));
 
  const [activeTab, setActiveTab] = useState<TabsValue>(pageTab || 'Notification');
 
  const isMobile = useMediaQuery('(max-width: 768px)');


  const handleTabChange = (value: TabsValue): void => {
    if (document.title != value) {
      document.title = String( value?.toString());
    }
    navigate(`/manage-company/${value}`)
    
    // if(organizationId){
    //   navigate(`/account/Account Details`);
    // }
    setActiveTab(value);
  };

  const handleFocus = (tab : string | TabsValue) => {
    if (tab === 'Notifications' && notificationsRef.current) {
      notificationsRef.current.focus();
    }
    // else if(tab === 'ManageCompanies' && managecompaniesRef.current){
    //   managecompaniesRef.current.focus();
    // }lse if(tab === 'ManageCompanies' && managecompaniesRef.current){
    //   managecompaniesRef.current.focus();
    // }
  };
  useEffect(() => {
    if (pageTab === ":pageTab") {
      navigate(`/manage-company/Notifications`);
    } else {
      setActiveTab(pageTab || 'Notifications');
    }
    handleFocus(pageTab ?? 'Notifications');
    document.title = String( pageTab?.toString());
  }, [pageTab, navigate]);

  useEffect(() => {
    // Set focus to the hidden element first
    if (hiddenRef.current) {
      hiddenRef.current.focus();
    }
    // After a short delay, set focus to the active tab content
    setTimeout(() => {
      window.addEventListener('keydown' , handleKeyForHeadingLevelOne)
      handleFocus(activeTab);
      return () => {
        window.removeEventListener('keydown' , handleKeyForHeadingLevelOne)
      }
    }, 100);
  }, [activeTab]);


  function handleKeyForHeadingLevelOne(event: any) {    
    if (event.keyCode === 72  || event.keyCode === 39 ) {
      let ref: React.RefObject<HTMLDivElement> | null = null;
  
      switch (activeTab) {
        case 'Notifications':
          ref = notificationsRef;
          break;
        case 'ManageCompanies':
          ref = managecompaniesRef;
          break;

        default:
          break;
      }
  
      if (ref && ref.current) {
        const h2Element = ref.current.querySelector('h1');
        if (h2Element) {
          h2Element.focus();
          // h2Element.style.border = '1px solid #5b5eff'
        }
      }
    }
  }  
  return (
    <main className={styles.tabContainer}  >
        <div ref={hiddenRef} tabIndex={-1} style={{ position: 'absolute', left: '-9999px' }} />
    <Tabs
        id='mainContent'
        activateTabWithKeyboard={false}
        value={activeTab}
      onTabChange={handleTabChange}
      orientation= { isMobile ? "horizontal" : "vertical"} defaultValue={pageTab}>
          <Tabs.List className={styles['mantine-Tabs-tabsList']}>
            <Tabs.Tab  
              icon={<Mail  />} value="Notifications" >
              {t('nav.notifications')}
            </Tabs.Tab>
            
            {/* <Tabs.Tab  
              icon={<Trello  />} value="manage-companies" >
              {t('nav.ManageCompanies')}
            </Tabs.Tab> */}

          </Tabs.List>

          <Tabs.Panel className={styles['mantine-Tabs-panel']} value="Notifications" ref={notificationsRef}>
              <Notification/>
          </Tabs.Panel>


          {/* <Tabs.Panel className={styles['mantine-Tabs-panel']} value="manage-companies" ref={managecompaniesRef}>
              <ManageCompanies/>
          </Tabs.Panel> */}
          {/* <Tabs.Panel className={styles['mantine-Tabs-panel']} value="company" ref={notificationsRef}>
              <MangeCompany />
          </Tabs.Panel>    */}

        </Tabs>
    </main>
  );
};

export default ManageCompany;
